import type { TOC } from '@ember/component/template-only';
import { LinkTo } from '@ember/routing';
import MessageBox from 'garaje/components/ui/classic/message-box';
import SettingsPanel from 'garaje/components/ui/classic/settings-panel';

export default <template>
  <SettingsPanel @isOpen={{true}} data-test-visual-compliance-upgrade as |sp|>
    {{#let sp.header sp.body as |PanelHeader PanelBody|}}
      <PanelHeader
        @iconUri="/assets/images/integrations/visual-compliance.png"
        @title="Visual Compliance"
        @description="Check if visitors appear on third-party lists of restricted parties."
        @showCancel={{false}}
      >
        <button data-test-visual-compliance-install type="button" disabled class="btn btn--small btn--brand disabled">
          Install
        </button>
      </PanelHeader>
      <PanelBody as |PanelContent|>
        <PanelContent @style="inset">
          <MessageBox @type="warning" @header="App update required" class="mt-4">
            <p class="mb-0">
              Version
              {{@minimumVersion}}
              or higher of the Envoy Visitors iPad app is required.
              <LinkTo @route="visitors.devices.ipads">Manage iPads →</LinkTo>
            </p>
          </MessageBox>
        </PanelContent>
      </PanelBody>
    {{/let}}
  </SettingsPanel>
</template> satisfies TOC<{
  Args: {
    minimumVersion: string;
  };
}>;
